export default __webpack_public_path__ + "static/media/doorlock.2c628219.png";